import type { FC } from "react";

import { DatePicker } from "@recobra/ui/custom/date-picker";

import { getErrorMessage, useFieldContext } from "./context";
import { FieldShell } from "./FieldShell";

export const DateField: FC<{
  label: string;
  id?: string;
  colSpan?: 1 | 2;
  hint?: string;
  placeholder?: string;
  required?: boolean;
  minDate?: Date;
  maxDate?: Date;
}> = ({ label, id, colSpan, hint, placeholder, required, minDate, maxDate }) => {
  const field = useFieldContext<string | undefined>();
  const errorMessage = getErrorMessage(field.state.meta.errors[0]);

  return (
    <FieldShell
      label={label}
      id={id}
      colSpan={colSpan}
      required={required}
      hint={hint}
      errorMessage={errorMessage}
    >
      <DatePicker
        id={id}
        aria-label={label}
        value={field.state.value}
        onChange={(value) => field.handleChange(value)}
        onBlur={field.handleBlur}
        placeholder={placeholder}
        minDate={minDate}
        maxDate={maxDate}
        required={required}
        aria-invalid={Boolean(errorMessage)}
      />
    </FieldShell>
  );
};
